// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResults-cls1__QR","cls2":"AutoCompleteResults-cls2_sKM AutoCompleteResults-cls1__QR"};